App.directive('appUsernavbar', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/usernavbar.html',
        restrict: 'E',
        replace: true
    };
  
  })